import {
  DeleteButton,
  PerpetratorList,
  PerpetratorName,
  PerpetratorPill,
  Perpetrators,
} from './EventPerpetratorList.styles';
import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'src/components/atoms';
import { Label } from 'src/components/atomsLegacy';
import { StyledIconInButton } from 'src/components/foundations/foundations.styles';
import { updateCurrentEvent } from 'src/creators/MCC.creators';
import { MCCEventType, State } from 'src/types';

type Props = ReturnType<typeof mapStateToProps> & {
  label?: string;
  perpetrators: { name: string }[];
  onClick: () => void;
  updateCurrentEvent: (
    event: MCCEventType,
    key?: string,
    value?: any,
  ) => Promise<any>;
};

const Component = ({
  label,
  perpetrators,
  onClick,
  currentEvent,
  updateCurrentEvent,
}: Props) => (
  <Perpetrators>
    {label && <Label>{label}</Label>}
    {perpetrators.length > 0 ? (
      <PerpetratorList>
        {perpetrators.map((perpetrator, index) => (
          <PerpetratorPill
            key={perpetrator.name}
            data-testid={`perpetrator-list/${perpetrator.name}`}
          >
            <PerpetratorName>{perpetrator.name}</PerpetratorName>
            <DeleteButton
              onClick={async (e) => {
                e.preventDefault();
                if (currentEvent) {
                  const newPerpetrators = [...currentEvent.perpetrators];
                  newPerpetrators.splice(index, 1);
                  await updateCurrentEvent(
                    currentEvent,
                    'perpetrators',
                    newPerpetrators,
                  );
                }
              }}
            >
              <img
                src="/assets/close-icon-grey.svg"
                alt="Delete"
                height="12px"
                width="12px"
              />
            </DeleteButton>
          </PerpetratorPill>
        ))}
      </PerpetratorList>
    ) : (
      <span />
    )}
    <Button
      data-testid="add-perpetrator"
      onClick={(e: React.MouseEvent) => {
        e.preventDefault();
        onClick();
      }}
      variant="primary"
      size="small"
    >
      <StyledIconInButton
        size="small"
        position="left"
        className="uil uil-user-plus"
      />
      Add named offender
    </Button>
  </Perpetrators>
);

const mapStateToProps = (state: State) => ({
  currentEvent: state.manualCaseCreation.mccReducer.currentEvent,
});

const mapDispatchToProps = {
  updateCurrentEvent,
};

export const EventPerpetratorList = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Component);
